import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Table from './TableOpcao';
import ModalOpcao from './ModalOpcao';

class ConfiguracaoSistema extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            index: -1,

            item: {},

            valor: ''
        }

        this.head = [
            {nome: 'Grupo', campo: 'grupo', width: '20%'},                
            {nome: 'Chave', campo: 'chave', width: '35%'},
            {nome: 'Valor', campo: 'valor', width: '35%'},            
        ]; 
    }       
    
    onRefresh() {
        this.props.onRefresh(this.state.valor, this.state.index);
        this.setState({item: {}, index: -1, valor: ''});
    }

    render() {
        return(
            <Fragment>   
                <ModalOpcao
                    show={this.state.index > -1}                    
                    
                    header={this.state.item.grupo}
                    component={this}
                    item={this.state.item}     
                    valor={this.state.valor}

                    fechar={() => this.setState({index: -1, item: {}, valor: ''})}

                    onChange={(e) => this.setState({valor: e.target.value})}                    
                    onRefresh={() => this.onRefresh()}
                />

                <Table 
                    head={this.head}
                    body={this.props.form.configuracao}     

                    onClick={(item, index) => this.setState({item: item, index: index, valor: item.valor})}
                />
            </Fragment>
        )
    }
}

export default ConfiguracaoSistema;